export const getDescription = (start, end, transcript) => {
  let resultText = "";

  for (const paragraph of transcript) {
    for (const word of paragraph.children[0].words) {
      if (word.start >= start && word.end <= end) {
        resultText += `${word.text} `;
      } else if (word.end > end) {
        break;
      }
    }
  }

  return resultText.trim();
};
